import PropTypes from 'prop-types';

import designProLogo from 'assets/designProLogo.svg';
import designProTextIcon from 'assets/designProTextIcon.svg';

import styles from './styles.module.scss';

export const PluginSignin = ({ loginButton }) => (
  <div className={styles['signin-page']}>
    <div className={styles['auth-modal']}>
      <div className={styles['title-container']}>
        <img width={26} height={26} src={designProLogo} alt="design pro logo" />
        <img className={styles['text-icon']} src={designProTextIcon} alt="design pro text icon" />
      </div>
      <span className={styles['description']}>
        Sign in with Google or create a free DesignPro account
      </span>
      {loginButton}
    </div>
  </div>
);

PluginSignin.propTypes = {
  loginButton: PropTypes.node,
};
